 <template>
  <div>
    <NavigationBar />
    <router-view></router-view>
  </div>
</template>

<script>
import NavigationBar from './components/NavigationBar.vue';
export default {
  components: {
    NavigationBar,
  },
  name: 'App'
}
</script>
<style>
#app{
  margin: -8px -8px auto;
}
</style>
